export const INTERNET_TYPES = {
  ethernet: 'Ethernet',
  none: 'NONE',
  fixedWireless: 'Fixed Wireless',
  wireless: 'Wireless',
  wirelessAndEthernet: 'Wireless & Ethernet',
};

export const DPSK_TYPES = {
  group: 'group',
};

export const DPSK_MIN_LENGTH = 8;

export const AUTH_METHODS = {
  ipv6: '802.1x - IPv6',
  dot1x: '802.1x',
  none: 'None',
  dhcp: 'DHCP',
  static: 'Static',
  wireless: 'Wireless',
};
